import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import logo from '../../assets/logo-danes.png';
import BrandLogo from '../common/BrandLogo';

const PaymentMethodScreen = () => {
    const { total } = useCart();
    const navigate = useNavigate();
    const [isAnimating, setIsAnimating] = useState(false);
    const [showAnimation, setShowAnimation] = useState(false);

    useEffect(() => {
        setShowAnimation(true);
    }, []);

    const handleMethodSelect = (method) => {
        if (method === 'cash') {
            return;
        }

        console.log('Método seleccionado:', method);
        setIsAnimating(true);

        setTimeout(() => {
            navigate('/operate-card');
        }, 400);
    };

    const handleBack = () => {
        setIsAnimating(true);
        setTimeout(() => {
            navigate('/');
        }, 300);
    };

    return (
        <div className="payment-method-container" style={{ backgroundColor: 'transparent' }}>
            <BrandLogo delay={0.3} topPosition="55px" />

            <div className="payment-method-header">
                <button onClick={handleBack} className="back-button">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
                    </svg>
                </button>

                <img src={logo} alt="Danés" className="header-logo" />

                <div className="header-text">
                    <div className="payment-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                        </svg>
                    </div>
                    <div>
                        <h1 className="method-title">Selecciona tu Método de Pago</h1>
                    </div>
                </div>
            </div>

            <div className="methods-section">
                <div className="total-display">
                    <p className="total-label">Total a Pagar</p>
                    <h2 className="total-amount">${total.toLocaleString()}</h2>
                </div>

                <div className="methods-container">

                    <div
                        className={`method-card card-method ${showAnimation ? 'animate-in' : ''}`}
                        onClick={() => handleMethodSelect('card')}
                        style={{ animationDelay: '200ms' }}
                    >
                        <div className="method-icon-container">
                            <div className="method-icon card-icon">
                                <svg viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M20 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" />
                                </svg>
                            </div>
                        </div>

                        <div className="method-content">
                            <h2 className="method-name">Tarjeta</h2>
                            <p className="method-description">Débito o Crédito</p>
                            <div className="method-features">
                                <span className="feature">Rápido y Seguro</span>
                                <span className="feature">Sin Contacto</span>
                            </div>
                        </div>

                        <div className="method-arrow">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </div>

                        <div className="hover-effect"></div>
                    </div>

                </div>
            </div>


            <style jsx>{`
                .payment-method-container {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    opacity: ${isAnimating ? 0.7 : 1};
                    transform: ${isAnimating ? 'scale(0.98)' : 'scale(1)'};
                    transition: all 300ms ease-out;
                    position: relative;
                }

                .payment-method-header {
                    background: #009542;
                    padding: 3.3rem 1.0rem;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    display: flex;
                    align-items: center;
                    gap: 1.5rem;
                    position: relative;
                    z-index: 2;
                }

                .back-button {
                    width: 56px;
                    height: 56px;
                    border: none;
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 16px;
                    color: white;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 200ms ease;
                    flex-shrink: 0;
                }

                .back-button:hover {
                    background: rgba(255, 255, 255, 0.3);
                }

                .header-logo {
                    height: 80px;
                    width: auto;
                    flex-shrink: 0;
                }

                .header-text {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    gap: 1.5rem;
                }

                .payment-icon {
                    width: 64px;
                    height: 64px;
                    background: rgba(255, 255, 255, 0.2);
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    flex-shrink: 0;
                }

                .payment-icon svg {
                    width: 36px;
                    height: 36px;
                }

                .method-title {
                    font-size: 2rem;
                    font-weight: 700;
                    color: white;
                    margin: 0;
                }

                .methods-section {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 3rem 2rem;
                    position: relative;
                    z-index: 1;
                }

                .total-display {
                    text-align: center;
                    margin-bottom: 3rem;
                    background: white;
                    padding: 2rem 3rem;
                    border-radius: 24px;
                    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
                    max-width: 600px;
                    width: 100%;
                }

                .total-label {
                    font-size: 1.5rem;
                    color: #6b7280;
                    font-weight: 600;
                    margin: 0 0 0.5rem 0;
                }

                .total-amount {
                    font-size: 4.5rem;
                    font-weight: 900;
                    color: #009542;
                    margin: 0;
                    line-height: 1;
                }

                .methods-container {
                    display: flex;
                    gap: 2rem;
                    max-width: 1200px;
                    width: 100%;
                }

                .method-card {
                    flex: 1;
                    background: #E5DFD2;
                    border: 3px solid #009542;
                    border-radius: 24px;
                    padding: 3rem;
                    position: relative;
                    overflow: hidden;
                    cursor: pointer;
                    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
                    box-shadow: 0 6px 25px rgba(0, 0, 0, 0.15);
                    display: flex;
                    flex-direction: column;
                    opacity: 0;
                }

                .method-card.animate-in {
                    animation: slideInUp 500ms ease-out forwards;
                }

                .method-card.card-method {
                    border: 4px solid #009542;
                }

                .method-card.card-method:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 12px 40px rgba(24, 22, 19, 0.3);
                }

                .method-card.cash-method {
                    border: 4px solid #e5e7eb;
                    background: #f9fafb;
                }

                .method-card.disabled {
                    cursor: not-allowed;
                    opacity: 0.6;
                }

                .method-icon-container {
                    margin-bottom: 2rem;
                    display: flex;
                    justify-content: center;
                }

                .method-icon {
                    width: 120px;
                    height: 120px;
                    border-radius: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .card-icon {
                    background: linear-gradient(135deg, #4285f4 0%, #357ae8 100%);
                    color: white;
                }

                .card-icon svg {
                    width: 64px;
                    height: 64px;
                }

                .cash-icon {
                    background: #e5e7eb;
                    color: #9ca3af;
                }

                .cash-icon svg {
                    width: 64px;
                    height: 64px;
                }

                .method-content {
                    flex: 1;
                    text-align: center;
                }

                .method-name {
                    font-size: 2.5rem;
                    font-weight: 900;
                    color: #1f2937;
                    margin: 0 0 0.5rem 0;
                }

                .method-description {
                    font-size: 1.25rem;
                    color: #6b7280;
                    margin: 0 0 2rem 0;
                    font-weight: 600;
                }

                .method-features {
                    display: flex;
                    flex-direction: column;
                    gap: 0.75rem;
                    align-items: center;
                }

                .feature {
                    padding: 0.75rem 1.5rem;
                    background: #00954215;
                    color: #009542;
                    border-radius: 20px;
                    font-size: 1rem;
                    font-weight: 700;
                }

                .feature.disabled {
                    background: #f3f4f6;
                    color: #9ca3af;
                }

                .method-arrow {
                    position: absolute;
                    bottom: 2rem;
                    right: 2rem;
                    width: 64px;
                    height: 64px;
                    background: #009542;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    transition: all 300ms ease;
                }

                .method-arrow.disabled {
                    background: #9ca3af;
                }

                .method-card:hover:not(.disabled) .method-arrow {
                    transform: scale(1.2);
                    box-shadow: 0 8px 25px rgba(24, 22, 19, 0.5);
                }

                .disabled-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: repeating-linear-gradient(
                        45deg,
                        transparent,
                        transparent 10px,
                        rgba(156, 163, 175, 0.1) 10px,
                        rgba(156, 163, 175, 0.1) 20px
                    );
                    pointer-events: none;
                }

                .hover-effect {
                    position: absolute;
                    top: 0;
                    left: -100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(
                        90deg,
                        transparent,
                        rgba(255, 255, 255, 0.3),
                        transparent
                    );
                    transition: left 500ms ease;
                }

                .method-card:hover .hover-effect {
                    left: 100%;
                }

                .payment-info {
                    background: white;
                    padding: 2rem;
                    border-top: 2px solid #f0f0f0;
                    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
                    position: relative;
                    z-index: 1;
                }

                .info-container {
                    max-width: 800px;
                    margin: 0 auto;
                }

                .security-info {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 1.5rem;
                    text-align: center;
                }

                .security-icon {
                    width: 56px;
                    height: 56px;
                    background: linear-gradient(135deg, #10b981, #059669);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }

                .security-icon svg {
                    width: 28px;
                    height: 28px;
                    color: white;
                }

                .security-text h3 {
                    font-size: 1.5rem;
                    font-weight: 800;
                    color: #1f2937;
                    margin: 0 0 0.25rem 0;
                }

                .security-text p {
                    color: #6b7280;
                    margin: 0;
                    font-size: 1rem;
                }

                @keyframes slideInUp {
                    0% {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @media (max-width: 768px) {
                    .method-title {
                        font-size: 1.5rem;
                    }

                    .total-amount {
                        font-size: 3rem;
                    }
                    
                    .methods-container {
                        flex-direction: column;
                        gap: 2rem;
                    }
                    
                    .header-text {
                        flex-direction: column;
                        gap: 1rem;
                    }

                    .back-button {
                        position: absolute;
                        left: 1rem;
                        top: 1rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default PaymentMethodScreen;